import axios from "axios";
import store from "../store/store";

const pAxios = axios.create({
  baseURL: process.env.VUE_APP_SERVER_URL
});

pAxios.interceptors.response.use(
  response => response,
  error => {
    if (error.response === undefined) {
      store.commit("ui/setSnackbar", {
        text:
          "Não foi possível estabelecer conexão com o servidor. Verifique sua conexão com a internet."
      });
    } else if (error.response.status === 500) {
      store.commit("ui/setSnackbar", {
        text: "Problemas de conexão com o servidor. Tente novamente mais tarde."
      });
    }
    return Promise.reject(error);
  }
);

const sAxios = axios.create({
  baseURL: process.env.VUE_APP_SERVER_URL
});

sAxios.interceptors.request.use(
  config => {
    config.headers.Authorization = `Bearer ${localStorage.getItem(
      "authToken"
    )}`;
    return config;
  },
  error => Promise.reject(error)
);

sAxios.interceptors.response.use(
  response => response,
  async error => {
    if (error.response === undefined) {
      store.commit("ui/setSnackbar", {
        text:
          "Não foi possível estabelecer conexão com o servidor. Verifique sua conexão com a internet."
      });
    } else if (error.response.status === 500) {
      store.commit("ui/setSnackbar", {
        text: "Problemas de conexão com o servidor. Tente novamente mais tarde."
      });
    } else if (error.response.status === 401) {
      try {
        const refresh_token = localStorage.getItem("refreshToken");
        if (refresh_token == "") {
          throw "Sessão expirada. Faça login novamente";
        }

        const response = await axios.post(
          `${process.env.VUE_APP_SERVER_URL}/refresh-token`,
          {
            refresh_token
          }
        );
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("refreshToken", response.data.refresh_token);
        store.commit("usuarios/setUsuarioAtivo", response.data.usuario);
        store.commit("usuarios/setEmpresaAtiva", response.data.empresa_ativa);

        sAxios.defaults.headers[
          "Authorization"
        ] = `Bearer ${response.data.token}`;
        error.config.headers["Authorization"] = `Bearer ${response.data.token}`;
        return sAxios.request(error.config);
      } catch (err) {
        store.dispatch("usuarios/logout");
        window.location.reload();
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export const publicAxios = pAxios;
export const securedAxios = sAxios;
